module.exports = __webpack_public_path__ + "img/pdf.cd296a15.png";